import OverlayModal from '@/components/base/OverlayModal';
import QuickEntryForm, { QUICK_FORM_META, type QuickFormType } from '@/components/feature/QuickEntryForm';

interface QuickEntryFormModalProps {
  type: QuickFormType | null;
  onClose: () => void;
}

export default function QuickEntryFormModal({ type, onClose }: QuickEntryFormModalProps) {
  if (!type) return null;
  const meta = QUICK_FORM_META[type];

  return (
    <OverlayModal open onClose={onClose} label={meta.title}>
      <div className="p-6 md:p-7">
        <div className="flex items-center gap-2 mb-2">
          <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className={`${meta.icon} text-lg`}></i>
          </span>
          <span className="text-sm font-medium text-primary-600">{meta.eyebrow}</span>
        </div>
        <h3 className="font-heading text-lg md:text-xl font-bold leading-snug text-foreground-900">
          {meta.title}
        </h3>
        <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{meta.description}</p>

        <div className="mt-5">
          <QuickEntryForm type={type} />
        </div>
      </div>
    </OverlayModal>
  );
}